<template>
  <div class="bg-surface-default-mid rounded-lg p-24">
    <div class="mb-16 flex">
      <div class="relative shrink-0">
        <RevIllustration
          alt=""
          class="mr-16 w-40 flex-initial"
          :height="40"
          src="/img/product/seller/SellerAvatar.svg"
          :width="40"
        />
      </div>

      <ClientOnly>
        <div>
          <p class="body-1 mb-4 overflow-hidden">
            {{ i18n(translations.title) }}

            <RevLink
              v-if="isValidMerchantLink"
              data-qa="seller-info"
              :to="grade.merchant.link"
              @click="onSellerClick"
            >
              {{ grade.merchant.company }}
            </RevLink>
          </p>
          <p class="text-static-default-low body-2">
            {{
              i18n(translations.subtitle, {
                location: grade.merchant.country,
                since: grade.merchant.sellerSinceYear,
              })
            }}
          </p>
        </div>

        <template #fallback>
          <div class="grow">
            <RevSkeleton
              class="mb-4"
              height="24px"
              shape="rectangle"
              width="80px"
            />

            <RevSkeleton height="20px" shape="rectangle" width="100%" />
          </div>
        </template>
      </ClientOnly>
    </div>
    <div class="border-static-default-low flex border-t pt-20">
      <p class="body-2">
        {{ i18n(translations.paymentMethodAccepted) }}
      </p>

      <ClientOnly>
        <PaymentIcons
          class="ml-24 content-center justify-end"
          :methods="grade.paymentMethods"
        />

        <template #fallback>
          <div class="flex justify-end gap-4">
            <RevSkeleton height="20px" shape="rectangle" width="36px" />
            <RevSkeleton height="20px" shape="rectangle" width="36px" />
            <RevSkeleton height="20px" shape="rectangle" width="36px" />
            <RevSkeleton height="20px" shape="rectangle" width="36px" />
            <RevSkeleton height="20px" shape="rectangle" width="36px" />
            <RevSkeleton height="20px" shape="rectangle" width="36px" />
          </div>
        </template>
      </ClientOnly>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { productAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { RevSkeleton } from '@ds/components/Skeleton'

import { PaymentIcons } from '~/scopes/payment'

import translations from './Seller.translations'

const i18n = useI18n()
const { trackClick } = useTracking()

const props = defineProps<{
  grade: productAPI.GetBestOffersResponse[number]
}>()

const isValidMerchantLink = computed(() => {
  const { link } = props.grade.merchant

  return link && link.params.uuid && link.params.merchantName
})

function onSellerClick() {
  trackClick({
    zone: 'recap',
    name: 'seller',
    value:
      props.grade.merchant.countryCode || props.grade.merchant.country || '',
  })
}
</script>
